import { styled } from 'styled-components';
export const TextFieldContainer = styled.div.withConfig({
  componentId: "aui__sc-1tnmb8q-0"
})(["position:relative;text-align:start;background-color:var(--aui-surface);border-radius:0.5rem;"]);